// Resolve a chip-multi toggle against the two option flags that make a chip mean more
// than itself:
//
//   selectsAll  a meta chip (e.g. Worldwide) that turns every other chip on when
//               picked and clears everything when picked again. Toggling any single
//               chip keeps it in sync: on only when every other chip is on.
//   exclusive   a chip (e.g. None) that cannot coexist with any other answer. Picking
//               it clears the rest; picking anything else clears it.
//
// Returns the next selection. Whether the "+ Other" customs must be cleared too is the
// caller's business, since those live under a sibling key.
export const toggleChipValue = (selected, value, options) => {
  const allValues = options.map((o) => o.value)
  const exclusiveVals = options.filter((o) => o.exclusive).map((o) => o.value)
  const metaVal = (options.find((o) => o.selectsAll) || {}).value

  if (metaVal && value === metaVal) return selected.includes(value) ? [] : allValues

  if (exclusiveVals.includes(value)) {
    return selected.includes(value) ? selected.filter((v) => v !== value) : [value]
  }

  let next = selected.includes(value) ? selected.filter((v) => v !== value) : [...selected, value]
  if (exclusiveVals.length) next = next.filter((v) => !exclusiveVals.includes(v))
  if (metaVal) {
    const others = allValues.filter((v) => v !== metaVal)
    const allOthersOn = others.length > 0 && others.every((v) => next.includes(v))
    next = next.filter((v) => v !== metaVal)
    if (allOthersOn) next = [...next, metaVal]
  }
  return next
}

export const exclusiveValues = (options) => options.filter((o) => o.exclusive).map((o) => o.value)
